export enum UniFeAdsPosition {
  ABOVE_HEADER = 'above_header',
  ABOVE_ARTICLE = 'above_article',
  BELOW_ARTICLE = 'below_article',
  ABOVE_IMAGE = 'above_image',
  BELOW_IMAGE = 'below_image',
  COLUMN_STICKY = 'column_sticky',
  BELOW_PEREX = 'below_perex',
  UNDER_ARTICLE = 'under_article',
}